import getConfig from 'next/config';
import type { AxiosResponse } from 'axios';

// This seems like it should not be imported here
// Move APIs below into car finance folder?
import type {
  FormPayloadSchema,
  LoanRequest,
} from '../components/CarFinancePage/queries/schema/carFinance.schema';
import { motorFinanceGateway } from '../api/api-utils/commonApiUtils';

const {
  publicRuntimeConfig: { API_CLIENT_TIMEOUT },
} = getConfig();

const getCarFinance = (params: string) => {
  return motorFinanceGateway.get(`/v1/finance/application/load${params}`, {
    timeout: API_CLIENT_TIMEOUT,
  });
};

const loan = (payload: LoanRequest) => {
  return motorFinanceGateway.post('/v1/finance/calculate/loan', payload, {
    timeout: API_CLIENT_TIMEOUT,
  });
};

const submit = (payload: FormPayloadSchema) => {
  return motorFinanceGateway.post<AxiosResponse<unknown>>(
    '/v1/finance/application/apply',
    payload,
    {
      timeout: API_CLIENT_TIMEOUT,
    },
  );
};

export const carFinanceApi = {
  getCarFinance,
  loan,
  submit,
};
